module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mt-cell', {
    attrs: {
      "title": _vm.label,
      "isLink": "",
      "required": _vm.required,
      "disabled": _vm.disabled,
      "readonly": _vm.readonly,
      "titlewidth": _vm.titlewidth,
      "value-align": _vm.valueAlign
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleDisplayClick($event)
      }
    }
  }, [_c('div', {
    staticClass: "select-value"
  }, [(_vm.selectType === 'select') ? [_c('span', {
    class: [{
      'mt-color-grey-lv3': _vm.isDefalut
    }]
  }, [_vm._v(_vm._s(_vm.singleSelectDisplay()))])] : _vm._e(), (_vm.selectType === 'multi-select') ? [_c('span', {
    class: [{
      'mt-color-grey-lv3': _vm.isDefalut
    }]
  }, [_vm._v(_vm._s(_vm.multiSelectDisplay()))])] : _vm._t("display", null, {
    options: _vm.options,
    value: _vm.value
  })], 2), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectorShow),
      expression: "selectorShow"
    }],
    staticClass: "select-container mt-bg-lv2",
    style: ({
      height: _vm.cHeight + 'px'
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.selectType === 'select') ? [_c('mt-box-group', {
    model: {
      value: (_vm.currentValue),
      callback: function($$v) {
        _vm.currentValue = $$v
      },
      expression: "currentValue"
    }
  }, [_c('mt-cell-group', _vm._l((_vm.getOptions_select(_vm.options)), function(item) {
    return _c('mt-radiobox', {
      key: item.value,
      attrs: {
        "name": item.value,
        "iconpattern": _vm.iconpattern
      },
      on: {
        "click": _vm.handleClick_select
      }
    }, [_vm._v("\n              " + _vm._s(item.label) + "\n            ")])
  }))], 1)] : (_vm.selectType === 'multi-select') ? [(!_vm.getOptions_select(_vm.options).length) ? _c('div', {
    staticClass: "mint-no-data"
  }, [_c('img', {
    attrs: {
      "src": "http://cdnres.campusphere.cn/images/Nodata.png"
    }
  })]) : _c('mt-box-group', {
    style: ([{
      height: _vm.cHeight + 'px',
      overflow: 'auto',
      'padding-bottom': '49px'
    }]),
    model: {
      value: (_vm.currentValue),
      callback: function($$v) {
        _vm.currentValue = $$v
      },
      expression: "currentValue"
    }
  }, [_c('mt-cell-group', _vm._l((_vm.getOptions_select(_vm.options)), function(item) {
    return _c('mt-checkbox', {
      key: item.value,
      attrs: {
        "name": item.value,
        "disabled": item.disabled,
        "iconpattern": _vm.iconpattern,
        "align": _vm.align
      }
    }, [_vm._v("\n                  " + _vm._s(item.label) + "\n              ")])
  }))], 1), _c('selected-footer', {
    attrs: {
      "options": _vm.options,
      "iconpattern": _vm.iconpattern,
      "align": _vm.align
    },
    on: {
      "confirm-click": _vm.confirm_multiSelect
    },
    model: {
      value: (_vm.currentValue),
      callback: function($$v) {
        _vm.currentValue = $$v
      },
      expression: "currentValue"
    }
  })] : _vm._t("selector", null, {
    options: _vm.options,
    value: _vm.value
  })], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5972188a","hasScoped":false,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/select/src/select.vue
// module id = 396
// module chunks = 0